import { NicheForm } from "components/popups/NicheForm";
import { Popup } from "components/popups/Popup";
import { INicheForm, NicheFields, NicheFieldsNames } from "components/popups/NicheForm/NicheForm";
import "./EditNichePopup.scss";

interface IEditNichePopupProps {
  ticketId: string | null;
  isOpen: boolean;
  nicheFields: { [key in NicheFieldsNames]: NicheFields };
  preview: string | null;
  onSubmit: (data: INicheForm) => void;
  handleTicketId: (ticketId: string) => void;
  onClose: () => void;
}

export const EditNichePopup: React.FC<IEditNichePopupProps> = (props) => {
  const {
    ticketId,
    isOpen,
    onSubmit,
    handleTicketId,
    onClose,
    nicheFields,
    preview
  } = props;

  return (
    <Popup
      isOpen={isOpen}
      onClose={onClose}
      popupClass="EditNichePopup"
    >
      <NicheForm
        preview={preview}
        fields={nicheFields}
        ticketId={ticketId}
        onSubmit={onSubmit}
        handleTicketId={handleTicketId}
        btnTitle="Save"
      />
    </Popup>
  );
};
